// ====================================================================================
// donationProgress.module
// ====================================================================================

const url2Base = "https://spenden.twingle.de/donation-status/amount-";
const elements = document.querySelectorAll(".ctype-ce_donation_progress");

const getCurr = (val) => {
  return val.toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
  });
};

const getInt = (val, decimals) => {
  return val.toLocaleString("de-DE", {
    style: "decimal",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

const setAmount = (el, amount) => {
  let elAmount = el.element.querySelector(".amount");
  let elGoal = el.element.querySelector(".goal");

  let cAmount = amount / el.conversion;
  let cGoal = el.goal;
  let hasGoal = el.goal !== 0;

  if (hasGoal) {
    let percentage = (cAmount / el.goal) * 100;
    el.element.querySelector(".progress-bar").style.width = percentage + "%";
  }

  if (el.unit === "trees") {
    elAmount.innerHTML = `${getInt(cAmount, 0)} Bäume`;
    if (hasGoal) elGoal.innerHTML = `${getInt(cGoal, 0)} Bäume`;
  } else if (el.unit === "m2") {
    elAmount.innerHTML = `${getInt(cAmount, 2)} m²`;
    if (hasGoal) elGoal.innerHTML = `${getInt(cGoal, 2)} m²`;
  } else if (el.unit === "tons") {
    elAmount.innerHTML = `${getInt(cAmount, 2)} t`;
    if (hasGoal) elGoal.innerHTML = `${getInt(cGoal, 2)} t`;
  } else {
    elAmount.innerHTML = `${getCurr(cAmount)}`;
    if (hasGoal) elGoal.innerHTML = `${getCurr(cGoal)}`;
  }
};

const getCurrentAmount = async (el) => {
  let combinedAmount = el.analogue;

  let req0 = url2Base + el.id;
  let data0 = await fetch(req0)
    .then((response) => response.json()) // Parse the response as JSON
    .then((data) => data.status.amount)
    .catch((error) => 0);
    // console.log("data0", data0);
  combinedAmount += data0;

  if (el.id2) {
    let req1 = url2Base + el.id2;
    let data1 = await fetch(req1)
      .then((response) => response.json()) // Parse the response as JSON
      .then((data) => data.status.amount)
      .catch((error) => 0);
      // console.log("data1", data1);
    combinedAmount += data1;
  }

  if (el.id3) {
    let req2 = url2Base + el.id3;
    let data2 = await fetch(req2)
      .then((response) => response.json()) // Parse the response as JSON
      .then((data) => data.status.amount)
      .catch((error) => 0);
      // console.log("data2", data2);
    combinedAmount += data2;
  }

  // console.log("combinedAmount", combinedAmount);
  setAmount(el, combinedAmount);
};

export const init = () => {
  let attempts = 0;

  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      elements.forEach((element) => {
        let data = element.dataset;
        let baseUrl = data.url;
        let additionalURL2 = data.url2;
        let additionalURL3 = data.url3;
        let el = {
          element: element,
          conversion: parseFloat(data.conversion),
          goal: parseFloat(data.goal),
          analogue: parseFloat(data.analogue),
          unit: data.unit,
        };

        if (baseUrl !== "-") {
          let parsedBaseUrl = new URL(baseUrl);
          el.id = parsedBaseUrl.pathname.split("/").pop();
          if (additionalURL2 !== "-") {
            let parsedAdditionalURL2 = new URL(additionalURL2);
            el.id2 = parsedAdditionalURL2.pathname.split("/").pop();
          }
          if (additionalURL3 !== "-") {
            let parsedAdditionalURL3 = new URL(additionalURL3);
            el.id3 = parsedAdditionalURL3.pathname.split("/").pop();
          }
          getCurrentAmount(el);
          let timer = setInterval(() => getCurrentAmount(el), 30000);
          window.addEventListener("beforeunload", (event) => {
            clearInterval(timer);
          });
        } else {
          setAmount(el, parseFloat(data.analogue));
        }
      });
    } else {
      setTimeout(() => {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
